/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermosBcRouteImport } from './routes/termos-bc'
import { Route as ClerkRouteRouteImport } from './routes/clerk/route'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as EnviarSlugRouteImport } from './routes/enviar/$slug'
import { Route as errors503RouteImport } from './routes/(errors)/503'
import { Route as errors500RouteImport } from './routes/(errors)/500'
import { Route as errors404RouteImport } from './routes/(errors)/404'
import { Route as errors403RouteImport } from './routes/(errors)/403'
import { Route as errors401RouteImport } from './routes/(errors)/401'
import { Route as authSignUpRouteImport } from './routes/(auth)/sign-up'
import { Route as authSignIn2RouteImport } from './routes/(auth)/sign-in-2'
import { Route as authSignInRouteImport } from './routes/(auth)/sign-in'
import { Route as authResetPasswordRouteImport } from './routes/(auth)/reset-password'
import { Route as authOtpRouteImport } from './routes/(auth)/otp'
import { Route as authForgotPasswordRouteImport } from './routes/(auth)/forgot-password'
import { Route as ClerkAuthenticatedRouteRouteImport } from './routes/clerk/_authenticated/route'
import { Route as ClerkauthRouteRouteImport } from './routes/clerk/(auth)/route'
import { Route as AuthenticatedSettingsRouteRouteImport } from './routes/_authenticated/settings/route'
import { Route as AuthenticatedTreinamentoIndexRouteImport } from './routes/_authenticated/treinamento/index'
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated/settings/index'
import { Route as AuthenticatedSemPermissaoIndexRouteImport } from './routes/_authenticated/sem-permissao/index'
import { Route as AuthenticatedRegrasIndexRouteImport } from './routes/_authenticated/regras/index'
import { Route as AuthenticatedNovoDocumentoIndexRouteImport } from './routes/_authenticated/novo-documento/index'
import { Route as AuthenticatedModuloNaoContratadoIndexRouteImport } from './routes/_authenticated/modulo-nao-contratado/index'
import { Route as AuthenticatedMeusDocumentosIndexRouteImport } from './routes/_authenticated/meus-documentos/index'
import { Route as AuthenticatedIntegracaoIndexRouteImport } from './routes/_authenticated/integracao/index'
import { Route as AuthenticatedHelpCenterIndexRouteImport } from './routes/_authenticated/help-center/index'
import { Route as AuthenticatedGerenciarRolesIndexRouteImport } from './routes/_authenticated/gerenciar-roles/index'
import { Route as AuthenticatedFuncionariosIndexRouteImport } from './routes/_authenticated/funcionarios/index'
import { Route as AuthenticatedEnvioColaboradorIndexRouteImport } from './routes/_authenticated/envio-colaborador/index'
import { Route as AuthenticatedDocumentosIndexRouteImport } from './routes/_authenticated/documentos/index'
import { Route as AuthenticatedConsultaCrmIndexRouteImport } from './routes/_authenticated/consulta-crm/index'
import { Route as AuthenticatedColaboradoresAtestadosIndexRouteImport } from './routes/_authenticated/colaboradores-atestados/index'
import { Route as AuthenticatedCadastrarUsuarioIndexRouteImport } from './routes/_authenticated/cadastrar-usuario/index'
import { Route as AuthenticatedBackgroundCheckIndexRouteImport } from './routes/_authenticated/background-check/index'
import { Route as AuthenticatedAjudaFaqIndexRouteImport } from './routes/_authenticated/ajuda-faq/index'
import { Route as ClerkauthSignUpRouteImport } from './routes/clerk/(auth)/sign-up'
import { Route as ClerkauthSignInRouteImport } from './routes/clerk/(auth)/sign-in'
import { Route as AuthenticatedSettingsNotificationsRouteImport } from './routes/_authenticated/settings/notifications'
import { Route as AuthenticatedSettingsDisplayRouteImport } from './routes/_authenticated/settings/display'
import { Route as AuthenticatedSettingsAppearanceRouteImport } from './routes/_authenticated/settings/appearance'
import { Route as AuthenticatedSettingsAccountRouteImport } from './routes/_authenticated/settings/account'
import { Route as AuthenticatedErrorsErrorRouteImport } from './routes/_authenticated/errors/$error'
import { Route as AuthenticatedRelatoriosRedesIndexRouteImport } from './routes/_authenticated/relatorios/redes/index'
import { Route as AuthenticatedRelatoriosMaioresAtestadoresIndexRouteImport } from './routes/_authenticated/relatorios/maiores-atestadores/index'
import { Route as AuthenticatedRelatoriosDocumentosMesIndexRouteImport } from './routes/_authenticated/relatorios/documentos-mes/index'
import { Route as AuthenticatedRelatoriosCrmAtestadosIndexRouteImport } from './routes/_authenticated/relatorios/crm-atestados/index'
import { Route as AuthenticatedRelatoriosCidDiasIndexRouteImport } from './routes/_authenticated/relatorios/cid-dias/index'
import { Route as AuthenticatedRelatoriosAbsenteismoIndexRouteImport } from './routes/_authenticated/relatorios/absenteismo/index'
import { Route as AuthenticatedRelatoriosAbsenteismoSetorIndexRouteImport } from './routes/_authenticated/relatorios/absenteismo-setor/index'
import { Route as AuthenticatedBackgroundCheckUsoIndexRouteImport } from './routes/_authenticated/background-check/uso/index'
import { Route as AuthenticatedDocumentosCollectionIdRouteImport } from './routes/_authenticated/documentos/$collection/$id'

const TermosBcRoute = TermosBcRouteImport.update({
  id: '/termos-bc',
  path: '/termos-bc',
  getParentRoute: () => rootRouteImport,
} as any)
const ClerkRouteRoute = ClerkRouteRouteImport.update({
  id: '/clerk',
  path: '/clerk',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const EnviarSlugRoute = EnviarSlugRouteImport.update({
  id: '/enviar/$slug',
  path: '/enviar/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const errors503Route = errors503RouteImport.update({
  id: '/(errors)/503',
  path: '/503',
  getParentRoute: () => rootRouteImport,
} as any)
const errors500Route = errors500RouteImport.update({
  id: '/(errors)/500',
  path: '/500',
  getParentRoute: () => rootRouteImport,
} as any)
const errors404Route = errors404RouteImport.update({
  id: '/(errors)/404',
  path: '/404',
  getParentRoute: () => rootRouteImport,
} as any)
const errors403Route = errors403RouteImport.update({
  id: '/(errors)/403',
  path: '/403',
  getParentRoute: () => rootRouteImport,
} as any)
const errors401Route = errors401RouteImport.update({
  id: '/(errors)/401',
  path: '/401',
  getParentRoute: () => rootRouteImport,
} as any)
const authSignUpRoute = authSignUpRouteImport.update({
  id: '/(auth)/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const authSignIn2Route = authSignIn2RouteImport.update({
  id: '/(auth)/sign-in-2',
  path: '/sign-in-2',
  getParentRoute: () => rootRouteImport,
} as any)
const authSignInRoute = authSignInRouteImport.update({
  id: '/(auth)/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const authResetPasswordRoute = authResetPasswordRouteImport.update({
  id: '/(auth)/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const authOtpRoute = authOtpRouteImport.update({
  id: '/(auth)/otp',
  path: '/otp',
  getParentRoute: () => rootRouteImport,
} as any)
const authForgotPasswordRoute = authForgotPasswordRouteImport.update({
  id: '/(auth)/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ClerkAuthenticatedRouteRoute = ClerkAuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => ClerkRouteRoute,
} as any)
const ClerkauthRouteRoute = ClerkauthRouteRouteImport.update({
  id: '/(auth)',
  getParentRoute: () => ClerkRouteRoute,
} as any)
const AuthenticatedSettingsRouteRoute =
  AuthenticatedSettingsRouteRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedTreinamentoIndexRoute =
  AuthenticatedTreinamentoIndexRouteImport.update({
    id: '/treinamento/',
    path: '/treinamento/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSemPermissaoIndexRoute =
  AuthenticatedSemPermissaoIndexRouteImport.update({
    id: '/sem-permissao/',
    path: '/sem-permissao/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedRegrasIndexRoute =
  AuthenticatedRegrasIndexRouteImport.update({
    id: '/regras/',
    path: '/regras/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedNovoDocumentoIndexRoute =
  AuthenticatedNovoDocumentoIndexRouteImport.update({
    id: '/novo-documento/',
    path: '/novo-documento/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedModuloNaoContratadoIndexRoute =
  AuthenticatedModuloNaoContratadoIndexRouteImport.update({
    id: '/modulo-nao-contratado/',
    path: '/modulo-nao-contratado/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedMeusDocumentosIndexRoute =
  AuthenticatedMeusDocumentosIndexRouteImport.update({
    id: '/meus-documentos/',
    path: '/meus-documentos/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedIntegracaoIndexRoute =
  AuthenticatedIntegracaoIndexRouteImport.update({
    id: '/integracao/',
    path: '/integracao/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedHelpCenterIndexRoute =
  AuthenticatedHelpCenterIndexRouteImport.update({
    id: '/help-center/',
    path: '/help-center/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedGerenciarRolesIndexRoute =
  AuthenticatedGerenciarRolesIndexRouteImport.update({
    id: '/gerenciar-roles/',
    path: '/gerenciar-roles/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedFuncionariosIndexRoute =
  AuthenticatedFuncionariosIndexRouteImport.update({
    id: '/funcionarios/',
    path: '/funcionarios/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedEnvioColaboradorIndexRoute =
  AuthenticatedEnvioColaboradorIndexRouteImport.update({
    id: '/envio-colaborador/',
    path: '/envio-colaborador/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDocumentosIndexRoute =
  AuthenticatedDocumentosIndexRouteImport.update({
    id: '/documentos/',
    path: '/documentos/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedConsultaCrmIndexRoute =
  AuthenticatedConsultaCrmIndexRouteImport.update({
    id: '/consulta-crm/',
    path: '/consulta-crm/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedColaboradoresAtestadosIndexRoute =
  AuthenticatedColaboradoresAtestadosIndexRouteImport.update({
    id: '/colaboradores-atestados/',
    path: '/colaboradores-atestados/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedCadastrarUsuarioIndexRoute =
  AuthenticatedCadastrarUsuarioIndexRouteImport.update({
    id: '/cadastrar-usuario/',
    path: '/cadastrar-usuario/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedBackgroundCheckIndexRoute =
  AuthenticatedBackgroundCheckIndexRouteImport.update({
    id: '/background-check/',
    path: '/background-check/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAjudaFaqIndexRoute =
  AuthenticatedAjudaFaqIndexRouteImport.update({
    id: '/ajuda-faq/',
    path: '/ajuda-faq/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const ClerkauthSignUpRoute = ClerkauthSignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => ClerkauthRouteRoute,
} as any)
const ClerkauthSignInRoute = ClerkauthSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => ClerkauthRouteRoute,
} as any)
const AuthenticatedSettingsNotificationsRoute =
  AuthenticatedSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsDisplayRoute =
  AuthenticatedSettingsDisplayRouteImport.update({
    id: '/display',
    path: '/display',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsAppearanceRoute =
  AuthenticatedSettingsAppearanceRouteImport.update({
    id: '/appearance',
    path: '/appearance',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsAccountRoute =
  AuthenticatedSettingsAccountRouteImport.update({
    id: '/account',
    path: '/account',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedErrorsErrorRoute =
  AuthenticatedErrorsErrorRouteImport.update({
    id: '/errors/$error',
    path: '/errors/$error',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedRelatoriosRedesIndexRoute =
  AuthenticatedRelatoriosRedesIndexRouteImport.update({
    id: '/relatorios/redes/',
    path: '/relatorios/redes/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedRelatoriosMaioresAtestadoresIndexRoute =
  AuthenticatedRelatoriosMaioresAtestadoresIndexRouteImport.update({
    id: '/relatorios/maiores-atestadores/',
    path: '/relatorios/maiores-atestadores/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedRelatoriosDocumentosMesIndexRoute =
  AuthenticatedRelatoriosDocumentosMesIndexRouteImport.update({
    id: '/relatorios/documentos-mes/',
    path: '/relatorios/documentos-mes/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedRelatoriosCrmAtestadosIndexRoute =
  AuthenticatedRelatoriosCrmAtestadosIndexRouteImport.update({
    id: '/relatorios/crm-atestados/',
    path: '/relatorios/crm-atestados/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedRelatoriosCidDiasIndexRoute =
  AuthenticatedRelatoriosCidDiasIndexRouteImport.update({
    id: '/relatorios/cid-dias/',
    path: '/relatorios/cid-dias/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedRelatoriosAbsenteismoIndexRoute =
  AuthenticatedRelatoriosAbsenteismoIndexRouteImport.update({
    id: '/relatorios/absenteismo/',
    path: '/relatorios/absenteismo/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedRelatoriosAbsenteismoSetorIndexRoute =
  AuthenticatedRelatoriosAbsenteismoSetorIndexRouteImport.update({
    id: '/relatorios/absenteismo-setor/',
    path: '/relatorios/absenteismo-setor/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedBackgroundCheckUsoIndexRoute =
  AuthenticatedBackgroundCheckUsoIndexRouteImport.update({
    id: '/background-check/uso/',
    path: '/background-check/uso/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDocumentosCollectionIdRoute =
  AuthenticatedDocumentosCollectionIdRouteImport.update({
    id: '/documentos/$collection/$id',
    path: '/documentos/$collection/$id',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/clerk': typeof ClerkAuthenticatedRouteRoute
  '/termos-bc': typeof TermosBcRoute
  '/settings': typeof AuthenticatedSettingsRouteRouteWithChildren
  '/forgot-password': typeof authForgotPasswordRoute
  '/otp': typeof authOtpRoute
  '/reset-password': typeof authResetPasswordRoute
  '/sign-in': typeof authSignInRoute
  '/sign-in-2': typeof authSignIn2Route
  '/sign-up': typeof authSignUpRoute
  '/401': typeof errors401Route
  '/403': typeof errors403Route
  '/404': typeof errors404Route
  '/500': typeof errors500Route
  '/503': typeof errors503Route
  '/enviar/$slug': typeof EnviarSlugRoute
  '/': typeof AuthenticatedIndexRoute
  '/errors/$error': typeof AuthenticatedErrorsErrorRoute
  '/settings/account': typeof AuthenticatedSettingsAccountRoute
  '/settings/appearance': typeof AuthenticatedSettingsAppearanceRoute
  '/settings/display': typeof AuthenticatedSettingsDisplayRoute
  '/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/clerk/sign-in': typeof ClerkauthSignInRoute
  '/clerk/sign-up': typeof ClerkauthSignUpRoute
  '/ajuda-faq': typeof AuthenticatedAjudaFaqIndexRoute
  '/background-check': typeof AuthenticatedBackgroundCheckIndexRoute
  '/cadastrar-usuario': typeof AuthenticatedCadastrarUsuarioIndexRoute
  '/colaboradores-atestados': typeof AuthenticatedColaboradoresAtestadosIndexRoute
  '/consulta-crm': typeof AuthenticatedConsultaCrmIndexRoute
  '/documentos': typeof AuthenticatedDocumentosIndexRoute
  '/envio-colaborador': typeof AuthenticatedEnvioColaboradorIndexRoute
  '/funcionarios': typeof AuthenticatedFuncionariosIndexRoute
  '/gerenciar-roles': typeof AuthenticatedGerenciarRolesIndexRoute
  '/help-center': typeof AuthenticatedHelpCenterIndexRoute
  '/integracao': typeof AuthenticatedIntegracaoIndexRoute
  '/meus-documentos': typeof AuthenticatedMeusDocumentosIndexRoute
  '/modulo-nao-contratado': typeof AuthenticatedModuloNaoContratadoIndexRoute
  '/novo-documento': typeof AuthenticatedNovoDocumentoIndexRoute
  '/regras': typeof AuthenticatedRegrasIndexRoute
  '/sem-permissao': typeof AuthenticatedSemPermissaoIndexRoute
  '/settings/': typeof AuthenticatedSettingsIndexRoute
  '/treinamento': typeof AuthenticatedTreinamentoIndexRoute
  '/documentos/$collection/$id': typeof AuthenticatedDocumentosCollectionIdRoute
  '/background-check/uso': typeof AuthenticatedBackgroundCheckUsoIndexRoute
  '/relatorios/absenteismo-setor': typeof AuthenticatedRelatoriosAbsenteismoSetorIndexRoute
  '/relatorios/absenteismo': typeof AuthenticatedRelatoriosAbsenteismoIndexRoute
  '/relatorios/cid-dias': typeof AuthenticatedRelatoriosCidDiasIndexRoute
  '/relatorios/crm-atestados': typeof AuthenticatedRelatoriosCrmAtestadosIndexRoute
  '/relatorios/documentos-mes': typeof AuthenticatedRelatoriosDocumentosMesIndexRoute
  '/relatorios/maiores-atestadores': typeof AuthenticatedRelatoriosMaioresAtestadoresIndexRoute
  '/relatorios/redes': typeof AuthenticatedRelatoriosRedesIndexRoute
}
export interface FileRoutesByTo {
  '/clerk': typeof ClerkAuthenticatedRouteRoute
  '/termos-bc': typeof TermosBcRoute
  '/forgot-password': typeof authForgotPasswordRoute
  '/otp': typeof authOtpRoute
  '/reset-password': typeof authResetPasswordRoute
  '/sign-in': typeof authSignInRoute
  '/sign-in-2': typeof authSignIn2Route
  '/sign-up': typeof authSignUpRoute
  '/401': typeof errors401Route
  '/403': typeof errors403Route
  '/404': typeof errors404Route
  '/500': typeof errors500Route
  '/503': typeof errors503Route
  '/enviar/$slug': typeof EnviarSlugRoute
  '/': typeof AuthenticatedIndexRoute
  '/errors/$error': typeof AuthenticatedErrorsErrorRoute
  '/settings/account': typeof AuthenticatedSettingsAccountRoute
  '/settings/appearance': typeof AuthenticatedSettingsAppearanceRoute
  '/settings/display': typeof AuthenticatedSettingsDisplayRoute
  '/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/clerk/sign-in': typeof ClerkauthSignInRoute
  '/clerk/sign-up': typeof ClerkauthSignUpRoute
  '/ajuda-faq': typeof AuthenticatedAjudaFaqIndexRoute
  '/background-check': typeof AuthenticatedBackgroundCheckIndexRoute
  '/cadastrar-usuario': typeof AuthenticatedCadastrarUsuarioIndexRoute
  '/colaboradores-atestados': typeof AuthenticatedColaboradoresAtestadosIndexRoute
  '/consulta-crm': typeof AuthenticatedConsultaCrmIndexRoute
  '/documentos': typeof AuthenticatedDocumentosIndexRoute
  '/envio-colaborador': typeof AuthenticatedEnvioColaboradorIndexRoute
  '/funcionarios': typeof AuthenticatedFuncionariosIndexRoute
  '/gerenciar-roles': typeof AuthenticatedGerenciarRolesIndexRoute
  '/help-center': typeof AuthenticatedHelpCenterIndexRoute
  '/integracao': typeof AuthenticatedIntegracaoIndexRoute
  '/meus-documentos': typeof AuthenticatedMeusDocumentosIndexRoute
  '/modulo-nao-contratado': typeof AuthenticatedModuloNaoContratadoIndexRoute
  '/novo-documento': typeof AuthenticatedNovoDocumentoIndexRoute
  '/regras': typeof AuthenticatedRegrasIndexRoute
  '/sem-permissao': typeof AuthenticatedSemPermissaoIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/treinamento': typeof AuthenticatedTreinamentoIndexRoute
  '/documentos/$collection/$id': typeof AuthenticatedDocumentosCollectionIdRoute
  '/background-check/uso': typeof AuthenticatedBackgroundCheckUsoIndexRoute
  '/relatorios/absenteismo-setor': typeof AuthenticatedRelatoriosAbsenteismoSetorIndexRoute
  '/relatorios/absenteismo': typeof AuthenticatedRelatoriosAbsenteismoIndexRoute
  '/relatorios/cid-dias': typeof AuthenticatedRelatoriosCidDiasIndexRoute
  '/relatorios/crm-atestados': typeof AuthenticatedRelatoriosCrmAtestadosIndexRoute
  '/relatorios/documentos-mes': typeof AuthenticatedRelatoriosDocumentosMesIndexRoute
  '/relatorios/maiores-atestadores': typeof AuthenticatedRelatoriosMaioresAtestadoresIndexRoute
  '/relatorios/redes': typeof AuthenticatedRelatoriosRedesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/clerk': typeof ClerkRouteRouteWithChildren
  '/termos-bc': typeof TermosBcRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRouteRouteWithChildren
  '/clerk/(auth)': typeof ClerkauthRouteRouteWithChildren
  '/clerk/_authenticated': typeof ClerkAuthenticatedRouteRoute
  '/(auth)/forgot-password': typeof authForgotPasswordRoute
  '/(auth)/otp': typeof authOtpRoute
  '/(auth)/reset-password': typeof authResetPasswordRoute
  '/(auth)/sign-in': typeof authSignInRoute
  '/(auth)/sign-in-2': typeof authSignIn2Route
  '/(auth)/sign-up': typeof authSignUpRoute
  '/(errors)/401': typeof errors401Route
  '/(errors)/403': typeof errors403Route
  '/(errors)/404': typeof errors404Route
  '/(errors)/500': typeof errors500Route
  '/(errors)/503': typeof errors503Route
  '/enviar/$slug': typeof EnviarSlugRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/errors/$error': typeof AuthenticatedErrorsErrorRoute
  '/_authenticated/settings/account': typeof AuthenticatedSettingsAccountRoute
  '/_authenticated/settings/appearance': typeof AuthenticatedSettingsAppearanceRoute
  '/_authenticated/settings/display': typeof AuthenticatedSettingsDisplayRoute
  '/_authenticated/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/clerk/(auth)/sign-in': typeof ClerkauthSignInRoute
  '/clerk/(auth)/sign-up': typeof ClerkauthSignUpRoute
  '/_authenticated/ajuda-faq/': typeof AuthenticatedAjudaFaqIndexRoute
  '/_authenticated/background-check/': typeof AuthenticatedBackgroundCheckIndexRoute
  '/_authenticated/cadastrar-usuario/': typeof AuthenticatedCadastrarUsuarioIndexRoute
  '/_authenticated/colaboradores-atestados/': typeof AuthenticatedColaboradoresAtestadosIndexRoute
  '/_authenticated/consulta-crm/': typeof AuthenticatedConsultaCrmIndexRoute
  '/_authenticated/documentos/': typeof AuthenticatedDocumentosIndexRoute
  '/_authenticated/envio-colaborador/': typeof AuthenticatedEnvioColaboradorIndexRoute
  '/_authenticated/funcionarios/': typeof AuthenticatedFuncionariosIndexRoute
  '/_authenticated/gerenciar-roles/': typeof AuthenticatedGerenciarRolesIndexRoute
  '/_authenticated/help-center/': typeof AuthenticatedHelpCenterIndexRoute
  '/_authenticated/integracao/': typeof AuthenticatedIntegracaoIndexRoute
  '/_authenticated/meus-documentos/': typeof AuthenticatedMeusDocumentosIndexRoute
  '/_authenticated/modulo-nao-contratado/': typeof AuthenticatedModuloNaoContratadoIndexRoute
  '/_authenticated/novo-documento/': typeof AuthenticatedNovoDocumentoIndexRoute
  '/_authenticated/regras/': typeof AuthenticatedRegrasIndexRoute
  '/_authenticated/sem-permissao/': typeof AuthenticatedSemPermissaoIndexRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/_authenticated/treinamento/': typeof AuthenticatedTreinamentoIndexRoute
  '/_authenticated/documentos/$collection/$id': typeof AuthenticatedDocumentosCollectionIdRoute
  '/_authenticated/background-check/uso/': typeof AuthenticatedBackgroundCheckUsoIndexRoute
  '/_authenticated/relatorios/absenteismo-setor/': typeof AuthenticatedRelatoriosAbsenteismoSetorIndexRoute
  '/_authenticated/relatorios/absenteismo/': typeof AuthenticatedRelatoriosAbsenteismoIndexRoute
  '/_authenticated/relatorios/cid-dias/': typeof AuthenticatedRelatoriosCidDiasIndexRoute
  '/_authenticated/relatorios/crm-atestados/': typeof AuthenticatedRelatoriosCrmAtestadosIndexRoute
  '/_authenticated/relatorios/documentos-mes/': typeof AuthenticatedRelatoriosDocumentosMesIndexRoute
  '/_authenticated/relatorios/maiores-atestadores/': typeof AuthenticatedRelatoriosMaioresAtestadoresIndexRoute
  '/_authenticated/relatorios/redes/': typeof AuthenticatedRelatoriosRedesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/clerk'
    | '/termos-bc'
    | '/settings'
    | '/forgot-password'
    | '/otp'
    | '/reset-password'
    | '/sign-in'
    | '/sign-in-2'
    | '/sign-up'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/enviar/$slug'
    | '/'
    | '/errors/$error'
    | '/settings/account'
    | '/settings/appearance'
    | '/settings/display'
    | '/settings/notifications'
    | '/clerk/sign-in'
    | '/clerk/sign-up'
    | '/ajuda-faq'
    | '/background-check'
    | '/cadastrar-usuario'
    | '/colaboradores-atestados'
    | '/consulta-crm'
    | '/documentos'
    | '/envio-colaborador'
    | '/funcionarios'
    | '/gerenciar-roles'
    | '/help-center'
    | '/integracao'
    | '/meus-documentos'
    | '/modulo-nao-contratado'
    | '/novo-documento'
    | '/regras'
    | '/sem-permissao'
    | '/settings/'
    | '/treinamento'
    | '/documentos/$collection/$id'
    | '/background-check/uso'
    | '/relatorios/absenteismo-setor'
    | '/relatorios/absenteismo'
    | '/relatorios/cid-dias'
    | '/relatorios/crm-atestados'
    | '/relatorios/documentos-mes'
    | '/relatorios/maiores-atestadores'
    | '/relatorios/redes'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/clerk'
    | '/termos-bc'
    | '/forgot-password'
    | '/otp'
    | '/reset-password'
    | '/sign-in'
    | '/sign-in-2'
    | '/sign-up'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/enviar/$slug'
    | '/'
    | '/errors/$error'
    | '/settings/account'
    | '/settings/appearance'
    | '/settings/display'
    | '/settings/notifications'
    | '/clerk/sign-in'
    | '/clerk/sign-up'
    | '/ajuda-faq'
    | '/background-check'
    | '/cadastrar-usuario'
    | '/colaboradores-atestados'
    | '/consulta-crm'
    | '/documentos'
    | '/envio-colaborador'
    | '/funcionarios'
    | '/gerenciar-roles'
    | '/help-center'
    | '/integracao'
    | '/meus-documentos'
    | '/modulo-nao-contratado'
    | '/novo-documento'
    | '/regras'
    | '/sem-permissao'
    | '/settings'
    | '/treinamento'
    | '/documentos/$collection/$id'
    | '/background-check/uso'
    | '/relatorios/absenteismo-setor'
    | '/relatorios/absenteismo'
    | '/relatorios/cid-dias'
    | '/relatorios/crm-atestados'
    | '/relatorios/documentos-mes'
    | '/relatorios/maiores-atestadores'
    | '/relatorios/redes'
  id:
    | '__root__'
    | '/_authenticated'
    | '/clerk'
    | '/termos-bc'
    | '/_authenticated/settings'
    | '/clerk/(auth)'
    | '/clerk/_authenticated'
    | '/(auth)/forgot-password'
    | '/(auth)/otp'
    | '/(auth)/reset-password'
    | '/(auth)/sign-in'
    | '/(auth)/sign-in-2'
    | '/(auth)/sign-up'
    | '/(errors)/401'
    | '/(errors)/403'
    | '/(errors)/404'
    | '/(errors)/500'
    | '/(errors)/503'
    | '/enviar/$slug'
    | '/_authenticated/'
    | '/_authenticated/errors/$error'
    | '/_authenticated/settings/account'
    | '/_authenticated/settings/appearance'
    | '/_authenticated/settings/display'
    | '/_authenticated/settings/notifications'
    | '/clerk/(auth)/sign-in'
    | '/clerk/(auth)/sign-up'
    | '/_authenticated/ajuda-faq/'
    | '/_authenticated/background-check/'
    | '/_authenticated/cadastrar-usuario/'
    | '/_authenticated/colaboradores-atestados/'
    | '/_authenticated/consulta-crm/'
    | '/_authenticated/documentos/'
    | '/_authenticated/envio-colaborador/'
    | '/_authenticated/funcionarios/'
    | '/_authenticated/gerenciar-roles/'
    | '/_authenticated/help-center/'
    | '/_authenticated/integracao/'
    | '/_authenticated/meus-documentos/'
    | '/_authenticated/modulo-nao-contratado/'
    | '/_authenticated/novo-documento/'
    | '/_authenticated/regras/'
    | '/_authenticated/sem-permissao/'
    | '/_authenticated/settings/'
    | '/_authenticated/treinamento/'
    | '/_authenticated/documentos/$collection/$id'
    | '/_authenticated/background-check/uso/'
    | '/_authenticated/relatorios/absenteismo-setor/'
    | '/_authenticated/relatorios/absenteismo/'
    | '/_authenticated/relatorios/cid-dias/'
    | '/_authenticated/relatorios/crm-atestados/'
    | '/_authenticated/relatorios/documentos-mes/'
    | '/_authenticated/relatorios/maiores-atestadores/'
    | '/_authenticated/relatorios/redes/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  ClerkRouteRoute: typeof ClerkRouteRouteWithChildren
  TermosBcRoute: typeof TermosBcRoute
  authForgotPasswordRoute: typeof authForgotPasswordRoute
  authOtpRoute: typeof authOtpRoute
  authResetPasswordRoute: typeof authResetPasswordRoute
  authSignInRoute: typeof authSignInRoute
  authSignIn2Route: typeof authSignIn2Route
  authSignUpRoute: typeof authSignUpRoute
  errors401Route: typeof errors401Route
  errors403Route: typeof errors403Route
  errors404Route: typeof errors404Route
  errors500Route: typeof errors500Route
  errors503Route: typeof errors503Route
  EnviarSlugRoute: typeof EnviarSlugRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/termos-bc': {
      id: '/termos-bc'
      path: '/termos-bc'
      fullPath: '/termos-bc'
      preLoaderRoute: typeof TermosBcRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clerk': {
      id: '/clerk'
      path: '/clerk'
      fullPath: '/clerk'
      preLoaderRoute: typeof ClerkRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/enviar/$slug': {
      id: '/enviar/$slug'
      path: '/enviar/$slug'
      fullPath: '/enviar/$slug'
      preLoaderRoute: typeof EnviarSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/503': {
      id: '/(errors)/503'
      path: '/503'
      fullPath: '/503'
      preLoaderRoute: typeof errors503RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/500': {
      id: '/(errors)/500'
      path: '/500'
      fullPath: '/500'
      preLoaderRoute: typeof errors500RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/404': {
      id: '/(errors)/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof errors404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/403': {
      id: '/(errors)/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof errors403RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/401': {
      id: '/(errors)/401'
      path: '/401'
      fullPath: '/401'
      preLoaderRoute: typeof errors401RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/sign-up': {
      id: '/(auth)/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof authSignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/sign-in-2': {
      id: '/(auth)/sign-in-2'
      path: '/sign-in-2'
      fullPath: '/sign-in-2'
      preLoaderRoute: typeof authSignIn2RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/sign-in': {
      id: '/(auth)/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof authSignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/reset-password': {
      id: '/(auth)/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof authResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/otp': {
      id: '/(auth)/otp'
      path: '/otp'
      fullPath: '/otp'
      preLoaderRoute: typeof authOtpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/forgot-password': {
      id: '/(auth)/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof authForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clerk/_authenticated': {
      id: '/clerk/_authenticated'
      path: ''
      fullPath: '/clerk'
      preLoaderRoute: typeof ClerkAuthenticatedRouteRouteImport
      parentRoute: typeof ClerkRouteRoute
    }
    '/clerk/(auth)': {
      id: '/clerk/(auth)'
      path: ''
      fullPath: '/clerk'
      preLoaderRoute: typeof ClerkauthRouteRouteImport
      parentRoute: typeof ClerkRouteRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/treinamento/': {
      id: '/_authenticated/treinamento/'
      path: '/treinamento'
      fullPath: '/treinamento'
      preLoaderRoute: typeof AuthenticatedTreinamentoIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/sem-permissao/': {
      id: '/_authenticated/sem-permissao/'
      path: '/sem-permissao'
      fullPath: '/sem-permissao'
      preLoaderRoute: typeof AuthenticatedSemPermissaoIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/regras/': {
      id: '/_authenticated/regras/'
      path: '/regras'
      fullPath: '/regras'
      preLoaderRoute: typeof AuthenticatedRegrasIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/novo-documento/': {
      id: '/_authenticated/novo-documento/'
      path: '/novo-documento'
      fullPath: '/novo-documento'
      preLoaderRoute: typeof AuthenticatedNovoDocumentoIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/modulo-nao-contratado/': {
      id: '/_authenticated/modulo-nao-contratado/'
      path: '/modulo-nao-contratado'
      fullPath: '/modulo-nao-contratado'
      preLoaderRoute: typeof AuthenticatedModuloNaoContratadoIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/meus-documentos/': {
      id: '/_authenticated/meus-documentos/'
      path: '/meus-documentos'
      fullPath: '/meus-documentos'
      preLoaderRoute: typeof AuthenticatedMeusDocumentosIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/integracao/': {
      id: '/_authenticated/integracao/'
      path: '/integracao'
      fullPath: '/integracao'
      preLoaderRoute: typeof AuthenticatedIntegracaoIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/help-center/': {
      id: '/_authenticated/help-center/'
      path: '/help-center'
      fullPath: '/help-center'
      preLoaderRoute: typeof AuthenticatedHelpCenterIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/gerenciar-roles/': {
      id: '/_authenticated/gerenciar-roles/'
      path: '/gerenciar-roles'
      fullPath: '/gerenciar-roles'
      preLoaderRoute: typeof AuthenticatedGerenciarRolesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/funcionarios/': {
      id: '/_authenticated/funcionarios/'
      path: '/funcionarios'
      fullPath: '/funcionarios'
      preLoaderRoute: typeof AuthenticatedFuncionariosIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/envio-colaborador/': {
      id: '/_authenticated/envio-colaborador/'
      path: '/envio-colaborador'
      fullPath: '/envio-colaborador'
      preLoaderRoute: typeof AuthenticatedEnvioColaboradorIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/documentos/': {
      id: '/_authenticated/documentos/'
      path: '/documentos'
      fullPath: '/documentos'
      preLoaderRoute: typeof AuthenticatedDocumentosIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/consulta-crm/': {
      id: '/_authenticated/consulta-crm/'
      path: '/consulta-crm'
      fullPath: '/consulta-crm'
      preLoaderRoute: typeof AuthenticatedConsultaCrmIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/colaboradores-atestados/': {
      id: '/_authenticated/colaboradores-atestados/'
      path: '/colaboradores-atestados'
      fullPath: '/colaboradores-atestados'
      preLoaderRoute: typeof AuthenticatedColaboradoresAtestadosIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/cadastrar-usuario/': {
      id: '/_authenticated/cadastrar-usuario/'
      path: '/cadastrar-usuario'
      fullPath: '/cadastrar-usuario'
      preLoaderRoute: typeof AuthenticatedCadastrarUsuarioIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/background-check/': {
      id: '/_authenticated/background-check/'
      path: '/background-check'
      fullPath: '/background-check'
      preLoaderRoute: typeof AuthenticatedBackgroundCheckIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/ajuda-faq/': {
      id: '/_authenticated/ajuda-faq/'
      path: '/ajuda-faq'
      fullPath: '/ajuda-faq'
      preLoaderRoute: typeof AuthenticatedAjudaFaqIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/clerk/(auth)/sign-up': {
      id: '/clerk/(auth)/sign-up'
      path: '/sign-up'
      fullPath: '/clerk/sign-up'
      preLoaderRoute: typeof ClerkauthSignUpRouteImport
      parentRoute: typeof ClerkauthRouteRoute
    }
    '/clerk/(auth)/sign-in': {
      id: '/clerk/(auth)/sign-in'
      path: '/sign-in'
      fullPath: '/clerk/sign-in'
      preLoaderRoute: typeof ClerkauthSignInRouteImport
      parentRoute: typeof ClerkauthRouteRoute
    }
    '/_authenticated/settings/notifications': {
      id: '/_authenticated/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AuthenticatedSettingsNotificationsRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/display': {
      id: '/_authenticated/settings/display'
      path: '/display'
      fullPath: '/settings/display'
      preLoaderRoute: typeof AuthenticatedSettingsDisplayRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/appearance': {
      id: '/_authenticated/settings/appearance'
      path: '/appearance'
      fullPath: '/settings/appearance'
      preLoaderRoute: typeof AuthenticatedSettingsAppearanceRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/account': {
      id: '/_authenticated/settings/account'
      path: '/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof AuthenticatedSettingsAccountRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/errors/$error': {
      id: '/_authenticated/errors/$error'
      path: '/errors/$error'
      fullPath: '/errors/$error'
      preLoaderRoute: typeof AuthenticatedErrorsErrorRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/relatorios/redes/': {
      id: '/_authenticated/relatorios/redes/'
      path: '/relatorios/redes'
      fullPath: '/relatorios/redes'
      preLoaderRoute: typeof AuthenticatedRelatoriosRedesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/relatorios/maiores-atestadores/': {
      id: '/_authenticated/relatorios/maiores-atestadores/'
      path: '/relatorios/maiores-atestadores'
      fullPath: '/relatorios/maiores-atestadores'
      preLoaderRoute: typeof AuthenticatedRelatoriosMaioresAtestadoresIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/relatorios/documentos-mes/': {
      id: '/_authenticated/relatorios/documentos-mes/'
      path: '/relatorios/documentos-mes'
      fullPath: '/relatorios/documentos-mes'
      preLoaderRoute: typeof AuthenticatedRelatoriosDocumentosMesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/relatorios/crm-atestados/': {
      id: '/_authenticated/relatorios/crm-atestados/'
      path: '/relatorios/crm-atestados'
      fullPath: '/relatorios/crm-atestados'
      preLoaderRoute: typeof AuthenticatedRelatoriosCrmAtestadosIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/relatorios/cid-dias/': {
      id: '/_authenticated/relatorios/cid-dias/'
      path: '/relatorios/cid-dias'
      fullPath: '/relatorios/cid-dias'
      preLoaderRoute: typeof AuthenticatedRelatoriosCidDiasIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/relatorios/absenteismo/': {
      id: '/_authenticated/relatorios/absenteismo/'
      path: '/relatorios/absenteismo'
      fullPath: '/relatorios/absenteismo'
      preLoaderRoute: typeof AuthenticatedRelatoriosAbsenteismoIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/relatorios/absenteismo-setor/': {
      id: '/_authenticated/relatorios/absenteismo-setor/'
      path: '/relatorios/absenteismo-setor'
      fullPath: '/relatorios/absenteismo-setor'
      preLoaderRoute: typeof AuthenticatedRelatoriosAbsenteismoSetorIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/background-check/uso/': {
      id: '/_authenticated/background-check/uso/'
      path: '/background-check/uso'
      fullPath: '/background-check/uso'
      preLoaderRoute: typeof AuthenticatedBackgroundCheckUsoIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/documentos/$collection/$id': {
      id: '/_authenticated/documentos/$collection/$id'
      path: '/documentos/$collection/$id'
      fullPath: '/documentos/$collection/$id'
      preLoaderRoute: typeof AuthenticatedDocumentosCollectionIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
  }
}

interface AuthenticatedSettingsRouteRouteChildren {
  AuthenticatedSettingsAccountRoute: typeof AuthenticatedSettingsAccountRoute
  AuthenticatedSettingsAppearanceRoute: typeof AuthenticatedSettingsAppearanceRoute
  AuthenticatedSettingsDisplayRoute: typeof AuthenticatedSettingsDisplayRoute
  AuthenticatedSettingsNotificationsRoute: typeof AuthenticatedSettingsNotificationsRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
}

const AuthenticatedSettingsRouteRouteChildren: AuthenticatedSettingsRouteRouteChildren =
  {
    AuthenticatedSettingsAccountRoute: AuthenticatedSettingsAccountRoute,
    AuthenticatedSettingsAppearanceRoute: AuthenticatedSettingsAppearanceRoute,
    AuthenticatedSettingsDisplayRoute: AuthenticatedSettingsDisplayRoute,
    AuthenticatedSettingsNotificationsRoute:
      AuthenticatedSettingsNotificationsRoute,
    AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
  }

const AuthenticatedSettingsRouteRouteWithChildren =
  AuthenticatedSettingsRouteRoute._addFileChildren(
    AuthenticatedSettingsRouteRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedSettingsRouteRoute: typeof AuthenticatedSettingsRouteRouteWithChildren
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedErrorsErrorRoute: typeof AuthenticatedErrorsErrorRoute
  AuthenticatedAjudaFaqIndexRoute: typeof AuthenticatedAjudaFaqIndexRoute
  AuthenticatedBackgroundCheckIndexRoute: typeof AuthenticatedBackgroundCheckIndexRoute
  AuthenticatedCadastrarUsuarioIndexRoute: typeof AuthenticatedCadastrarUsuarioIndexRoute
  AuthenticatedColaboradoresAtestadosIndexRoute: typeof AuthenticatedColaboradoresAtestadosIndexRoute
  AuthenticatedConsultaCrmIndexRoute: typeof AuthenticatedConsultaCrmIndexRoute
  AuthenticatedDocumentosIndexRoute: typeof AuthenticatedDocumentosIndexRoute
  AuthenticatedEnvioColaboradorIndexRoute: typeof AuthenticatedEnvioColaboradorIndexRoute
  AuthenticatedFuncionariosIndexRoute: typeof AuthenticatedFuncionariosIndexRoute
  AuthenticatedGerenciarRolesIndexRoute: typeof AuthenticatedGerenciarRolesIndexRoute
  AuthenticatedHelpCenterIndexRoute: typeof AuthenticatedHelpCenterIndexRoute
  AuthenticatedIntegracaoIndexRoute: typeof AuthenticatedIntegracaoIndexRoute
  AuthenticatedMeusDocumentosIndexRoute: typeof AuthenticatedMeusDocumentosIndexRoute
  AuthenticatedModuloNaoContratadoIndexRoute: typeof AuthenticatedModuloNaoContratadoIndexRoute
  AuthenticatedNovoDocumentoIndexRoute: typeof AuthenticatedNovoDocumentoIndexRoute
  AuthenticatedRegrasIndexRoute: typeof AuthenticatedRegrasIndexRoute
  AuthenticatedSemPermissaoIndexRoute: typeof AuthenticatedSemPermissaoIndexRoute
  AuthenticatedTreinamentoIndexRoute: typeof AuthenticatedTreinamentoIndexRoute
  AuthenticatedDocumentosCollectionIdRoute: typeof AuthenticatedDocumentosCollectionIdRoute
  AuthenticatedBackgroundCheckUsoIndexRoute: typeof AuthenticatedBackgroundCheckUsoIndexRoute
  AuthenticatedRelatoriosAbsenteismoSetorIndexRoute: typeof AuthenticatedRelatoriosAbsenteismoSetorIndexRoute
  AuthenticatedRelatoriosAbsenteismoIndexRoute: typeof AuthenticatedRelatoriosAbsenteismoIndexRoute
  AuthenticatedRelatoriosCidDiasIndexRoute: typeof AuthenticatedRelatoriosCidDiasIndexRoute
  AuthenticatedRelatoriosCrmAtestadosIndexRoute: typeof AuthenticatedRelatoriosCrmAtestadosIndexRoute
  AuthenticatedRelatoriosDocumentosMesIndexRoute: typeof AuthenticatedRelatoriosDocumentosMesIndexRoute
  AuthenticatedRelatoriosMaioresAtestadoresIndexRoute: typeof AuthenticatedRelatoriosMaioresAtestadoresIndexRoute
  AuthenticatedRelatoriosRedesIndexRoute: typeof AuthenticatedRelatoriosRedesIndexRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedSettingsRouteRoute: AuthenticatedSettingsRouteRouteWithChildren,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedErrorsErrorRoute: AuthenticatedErrorsErrorRoute,
  AuthenticatedAjudaFaqIndexRoute: AuthenticatedAjudaFaqIndexRoute,
  AuthenticatedBackgroundCheckIndexRoute:
    AuthenticatedBackgroundCheckIndexRoute,
  AuthenticatedCadastrarUsuarioIndexRoute:
    AuthenticatedCadastrarUsuarioIndexRoute,
  AuthenticatedColaboradoresAtestadosIndexRoute:
    AuthenticatedColaboradoresAtestadosIndexRoute,
  AuthenticatedConsultaCrmIndexRoute: AuthenticatedConsultaCrmIndexRoute,
  AuthenticatedDocumentosIndexRoute: AuthenticatedDocumentosIndexRoute,
  AuthenticatedEnvioColaboradorIndexRoute:
    AuthenticatedEnvioColaboradorIndexRoute,
  AuthenticatedFuncionariosIndexRoute: AuthenticatedFuncionariosIndexRoute,
  AuthenticatedGerenciarRolesIndexRoute: AuthenticatedGerenciarRolesIndexRoute,
  AuthenticatedHelpCenterIndexRoute: AuthenticatedHelpCenterIndexRoute,
  AuthenticatedIntegracaoIndexRoute: AuthenticatedIntegracaoIndexRoute,
  AuthenticatedMeusDocumentosIndexRoute: AuthenticatedMeusDocumentosIndexRoute,
  AuthenticatedModuloNaoContratadoIndexRoute:
    AuthenticatedModuloNaoContratadoIndexRoute,
  AuthenticatedNovoDocumentoIndexRoute: AuthenticatedNovoDocumentoIndexRoute,
  AuthenticatedRegrasIndexRoute: AuthenticatedRegrasIndexRoute,
  AuthenticatedSemPermissaoIndexRoute: AuthenticatedSemPermissaoIndexRoute,
  AuthenticatedTreinamentoIndexRoute: AuthenticatedTreinamentoIndexRoute,
  AuthenticatedDocumentosCollectionIdRoute:
    AuthenticatedDocumentosCollectionIdRoute,
  AuthenticatedBackgroundCheckUsoIndexRoute:
    AuthenticatedBackgroundCheckUsoIndexRoute,
  AuthenticatedRelatoriosAbsenteismoSetorIndexRoute:
    AuthenticatedRelatoriosAbsenteismoSetorIndexRoute,
  AuthenticatedRelatoriosAbsenteismoIndexRoute:
    AuthenticatedRelatoriosAbsenteismoIndexRoute,
  AuthenticatedRelatoriosCidDiasIndexRoute:
    AuthenticatedRelatoriosCidDiasIndexRoute,
  AuthenticatedRelatoriosCrmAtestadosIndexRoute:
    AuthenticatedRelatoriosCrmAtestadosIndexRoute,
  AuthenticatedRelatoriosDocumentosMesIndexRoute:
    AuthenticatedRelatoriosDocumentosMesIndexRoute,
  AuthenticatedRelatoriosMaioresAtestadoresIndexRoute:
    AuthenticatedRelatoriosMaioresAtestadoresIndexRoute,
  AuthenticatedRelatoriosRedesIndexRoute:
    AuthenticatedRelatoriosRedesIndexRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

interface ClerkauthRouteRouteChildren {
  ClerkauthSignInRoute: typeof ClerkauthSignInRoute
  ClerkauthSignUpRoute: typeof ClerkauthSignUpRoute
}

const ClerkauthRouteRouteChildren: ClerkauthRouteRouteChildren = {
  ClerkauthSignInRoute: ClerkauthSignInRoute,
  ClerkauthSignUpRoute: ClerkauthSignUpRoute,
}

const ClerkauthRouteRouteWithChildren = ClerkauthRouteRoute._addFileChildren(
  ClerkauthRouteRouteChildren,
)

interface ClerkRouteRouteChildren {
  ClerkauthRouteRoute: typeof ClerkauthRouteRouteWithChildren
  ClerkAuthenticatedRouteRoute: typeof ClerkAuthenticatedRouteRoute
}

const ClerkRouteRouteChildren: ClerkRouteRouteChildren = {
  ClerkauthRouteRoute: ClerkauthRouteRouteWithChildren,
  ClerkAuthenticatedRouteRoute: ClerkAuthenticatedRouteRoute,
}

const ClerkRouteRouteWithChildren = ClerkRouteRoute._addFileChildren(
  ClerkRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  ClerkRouteRoute: ClerkRouteRouteWithChildren,
  TermosBcRoute: TermosBcRoute,
  authForgotPasswordRoute: authForgotPasswordRoute,
  authOtpRoute: authOtpRoute,
  authResetPasswordRoute: authResetPasswordRoute,
  authSignInRoute: authSignInRoute,
  authSignIn2Route: authSignIn2Route,
  authSignUpRoute: authSignUpRoute,
  errors401Route: errors401Route,
  errors403Route: errors403Route,
  errors404Route: errors404Route,
  errors500Route: errors500Route,
  errors503Route: errors503Route,
  EnviarSlugRoute: EnviarSlugRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
